var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/** Calculates Cluster matrix based on distance matrix reduces array. i.e. the top right triangle of the matrix
 * turned into the array.
 * @param distMatArray - reduced distance matrix array.
 * @param n - dimension of the distance matrix, i.e. side length.
 * @param methodCode - method code for the clustering algorithm. Method codes can be found in {@link LinkageMethodCode} object.
 * @returns Cluster matrix.
 */
export function getClusterMatrixWorker(distMatArray, n, methodCode) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise(function (resolve, reject) {
            const worker = new Worker(new URL('./clustering-worker', import.meta.url));
            worker.postMessage({ distMatArray, n, methodCode });
            worker.onmessage = ({ data: { error, clusterMatrix } }) => {
                worker.terminate();
                error ? reject(error) : resolve(clusterMatrix);
            };
        });
    });
}
//# sourceMappingURL=clustering-worker-creator.js.map